export default __webpack_public_path__ + "static/media/horse-slideLine.bd5372ab.png";